export enum AreaType {
    None = 'None',
    DriveTime = 'Drive Time',
    MileRadius = 'Mile Radius',
    Geography = 'Geography'
}

export enum GeographyType {
    National = 'National',
    Region = 'Region',
    State = 'State',
    DMA = 'DMA',
    ZipCode = 'Zip Code'
}

export interface GeographyDefinition {
    areaType: AreaType;
    geographyType: GeographyType;
    geographyKey: string;
    mileRadius: number;
    driveTime: number;
}

export enum NumericComparison
{
    EqualTo = "Equal To",
    AtLeast = "At Least",
    LessThan = "Less Than"
}

export interface NumericConstraint<T>
{
    value: T;
    comparison: NumericComparison;
}

export interface MarketPresenceOptions {
    geographyDefinition: GeographyDefinition;
    tradeAreaDefinition: GeographyDefinition;
    showTenants: boolean;
    numberOfLocations: [NumericComparison, number];
}

export interface VoidGapOptions {
    geography: GeographyDefinition;
    numberOfLocations: NumericConstraint<number>;
}

export interface SquareFootageOptions {
    min: number;
    max: number;
}

export enum GrowthType {
    GrowthRate = 'Growth Rate',
    LocationGrowth = 'Location Growth'
}

export enum GrowthPeriod {
    Last12Months = 'Last 12 Months'
}

export interface UnitsAndGrowthOptions {
    minLocations: number;
    maxLocations: number;
    growthType: GrowthType;
    growthPeriod: GrowthPeriod;
    rate: number;    
}

export interface LatLon {
    latitude: number;
    longitude: number;
}

export interface ViewportBounds {
    southWest: LatLon;
    northEast: LatLon;
    zoom: number;
}

export interface IVoidGapRequest {
    tenantSubcategories: string[];
    marketPresence: MarketPresenceOptions;
    voidGap: VoidGapOptions;
    squareFootage: SquareFootageOptions;
    unitsAndGrowth: UnitsAndGrowthOptions;
    viewportBounds: ViewportBounds;
}